import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from './Badge.js';
import { humanizeEnum } from '../utils/humanize.js';
/**
 * The single way to render a domain status across every app.
 *
 * Before this, status was drawn a different way on each surface (a solid
 * saturated pill here, a grey ghost there, plain uppercase text elsewhere, a
 * bare ✓/✗ glyph on credential lists), which broke recognition on the most-
 * scanned datum in the operator + buyer views. StatusBadge maps the raw status
 * to one muted tone (success / warning / danger / neutral) and one humanized
 * label, always as a low-emphasis `soft` chip.
 *
 * The map encodes the COMMON meaning of each status string. Where the same
 * string means the opposite in a niche domain (credit-hold ACTIVE is bad, not
 * good), pass an explicit `tone` to override.
 */
const STATUS_TONE = {
    // Good / terminal-positive
    ACTIVE: 'success',
    COMPLETED: 'success',
    PAID: 'success',
    DELIVERED: 'success',
    APPROVED: 'success',
    VERIFIED: 'success',
    SENT: 'success',
    // In-progress / needs attention
    UNDER_REVIEW: 'warning',
    PARTIAL: 'warning',
    PROSPECT: 'warning',
    IN_PROGRESS: 'warning',
    PENDING: 'warning',
    WARNED: 'warning',
    SCHEDULED: 'warning',
    APPLYING: 'warning',
    ONBOARDING: 'warning', // Phase 5g — approved, completing onboarding (in-progress)
    // Bad / terminal-negative
    SUSPENDED: 'danger',
    TERMINATED: 'danger',
    OVERDUE: 'danger',
    CANCELLED: 'danger',
    NO_SHOW: 'danger',
    DISPUTED: 'danger', // audit LOW — was falling through to neutral grey in the buyer shift view
    BOUNCED: 'danger',
    FAILED: 'danger',
    REJECTED: 'danger',
    EXPIRED: 'danger',
    // Inert
    DRAFT: 'neutral',
    VOIDED: 'neutral',
    NONE: 'neutral',
    CLOSED: 'neutral',
    // Informational
    ISSUED: 'forest',
};
export function StatusBadge({ status, tone, label, className }) {
    const key = (status ?? '').toUpperCase();
    const resolvedTone = tone ?? STATUS_TONE[key] ?? 'neutral';
    return (_jsx(Badge, { tone: resolvedTone, variant: "soft", className: className, children: label ?? humanizeEnum(status) }));
}
//# sourceMappingURL=StatusBadge.js.map